import React from 'react'

import { useGetWidget } from './_configs'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'

const EditWidgetForm = () => {
  const form = useForm()
  const config = useGetWidget(form.data?.type)
  const Form = config?.Form

  return <Form />
}

export default EditWidgetForm
